module.exports = __webpack_public_path__ + "img/fir_step.dc956961.png";